export const Apartments = () => {
  document.querySelector('body').classList.toggle('logo-background');
  window.location.href = 'http://stanovi.hollywoodhillns.rs/';
};
